import { useLang } from '@/i18n';
import EfIcon from '@elem/ui/ef-icon';
import EfProductCompareC from '@elem/ui/ef-product-compare-c';
import styles from './index.module.scss';
import { IMG_R3_UPS, IMG_R3_PLUS, IMG_R3_MAX, IMG_R3_MAX_PLUS } from '../../utils';


export default function TheComp() {
    const { t } = useLang('theProduct.TabC');

    const listA = {
        pc: IMG_R3_UPS,
        title: t('win3_a_title'),
        specList: [
            {
                desc: t('win3_a_item1_t'),
                title: (
                    <div className="win3_item_title">
                        <EfIcon className="win3_item_title_icon" pc="https://websiteoss.ecoflow.com/upload/image/1723727559364/d1.png" />
                        <div className="win3_item_title_text">{t('win3_a_item1_b')}</div>
                    </div>
                ),
            },
            {
                desc: t('win3_a_item2_t'),
                title: (
                    <div className="win3_item_title">
                        <EfIcon className="win3_item_title_icon" pc="https://websiteoss.ecoflow.com/upload/image/1723728127710/d2.png" />
                        <div className="win3_item_title_text">{t('win3_a_item2_b')}</div>
                    </div>
                ),
            },
            {
                desc: t('win3_a_item3_t'),
                title: (
                    <div className="win3_item_title">
                        <EfIcon className="win3_item_title_icon" pc="https://websiteoss.ecoflow.com/upload/image/1723728163210/d3.png" />
                        <div className="win3_item_title_text">{t('win3_a_item3_b')}</div>
                    </div>
                ),
            },
            {
                desc: t('win3_a_item4_t'),
                title: (
                    <div className="win3_item_title">
                        <EfIcon className="win3_item_title_icon" pc="https://websiteoss.ecoflow.com/upload/image/1723728127912/d4.png" />
                        <div className="win3_item_title_text">{t('win3_a_item4_b')}</div>
                    </div>
                ),
            },
        ],
    };

    const listB = {
        pc: IMG_R3_PLUS,
        title: t('win3_b_title'),
        specList: [
            {
                desc: t('win3_b_item1_t'),
                title: (
                    <div className="win3_item_title">
                        <EfIcon className="win3_item_title_icon" pc="https://websiteoss.ecoflow.com/upload/image/1723727559364/d1.png" />
                        <div className="win3_item_title_text">{t('win3_b_item1_b')}</div>
                    </div>
                ),
            },
            {
                desc: t('win3_b_item2_t'),
                title: (
                    <div className="win3_item_title">
                        <EfIcon className="win3_item_title_icon" pc="https://websiteoss.ecoflow.com/upload/image/1723728127710/d2.png" />
                        <div className="win3_item_title_text">{t('win3_b_item2_b')}</div>
                    </div>
                ),
            },
            {
                desc: t('win3_b_item3_t'),
                title: (
                    <div className="win3_item_title">
                        <EfIcon className="win3_item_title_icon" pc="https://websiteoss.ecoflow.com/upload/image/1723728163210/d3.png" />
                        <div className="win3_item_title_text">{t('win3_b_item3_b')}</div>
                    </div>
                ),
            },
            {
                desc: t('win3_b_item4_t'),
                title: (
                    <div className="win3_item_title">
                        <EfIcon className="win3_item_title_icon" pc="https://websiteoss.ecoflow.com/upload/image/1723728127912/d4.png" />
                        <div className="win3_item_title_text">{t('win3_b_item4_b')}</div>
                    </div>
                ),
            },
        ],
    };

    const listC = {
        pc: IMG_R3_MAX,
        title: t('win3_c_title'),
        specList: [
            {
                desc: t('win3_c_item1_t'),
                title: (
                    <div className="win3_item_title">
                        <EfIcon className="win3_item_title_icon" pc="https://websiteoss.ecoflow.com/upload/image/1723727559364/d1.png" />
                        <div className="win3_item_title_text">{t('win3_c_item1_b')}</div>
                    </div>
                ),
            },
            {
                desc: t('win3_c_item2_t'),
                title: (
                    <div className="win3_item_title">
                        <EfIcon className="win3_item_title_icon" pc="https://websiteoss.ecoflow.com/upload/image/1723728127710/d2.png" />
                        <div className="win3_item_title_text">{t('win3_c_item2_b')}</div>
                    </div>
                ),
            },
            {
                desc: t('win3_c_item3_t'),
                title: (
                    <div className="win3_item_title">
                        <EfIcon className="win3_item_title_icon" pc="https://websiteoss.ecoflow.com/upload/image/1723728163210/d3.png" />
                        <div className="win3_item_title_text">{t('win3_c_item3_b')}</div>
                    </div>
                ),
            },
            {
                desc: t('win3_c_item4_t'),
                title: (
                    <div className="win3_item_title">
                        <EfIcon className="win3_item_title_icon" pc="https://websiteoss.ecoflow.com/upload/image/1723728127912/d4.png" />
                        <div className="win3_item_title_text">{t('win3_c_item4_b')}</div>
                    </div>
                ),
            },
        ],
    };

    const listD = {
        pc: IMG_R3_MAX_PLUS,
        title: t('win3_d_title'),
        specList: [
            {
                desc: t('win3_d_item1_t'),
                title: (
                    <div className="win3_item_title">
                        <EfIcon className="win3_item_title_icon" pc="https://websiteoss.ecoflow.com/upload/image/1723727559364/d1.png" />
                        <div className="win3_item_title_text">{t('win3_d_item1_b')}</div>
                    </div>
                ),
            },
            {
                desc: t('win3_d_item2_t'),
                title: (
                    <div className="win3_item_title">
                        <EfIcon className="win3_item_title_icon" pc="https://websiteoss.ecoflow.com/upload/image/1723728127710/d2.png" />
                        <div className="win3_item_title_text">{t('win3_d_item2_b')}</div>
                    </div>
                ),
            },
            {
                desc: t('win3_d_item3_t'),
                title: (
                    <div className="win3_item_title">
                        <EfIcon className="win3_item_title_icon" pc="https://websiteoss.ecoflow.com/upload/image/1723728163210/d3.png" />
                        <div className="win3_item_title_text">{t('win3_d_item3_b')}</div>
                    </div>
                ),
            },
            {
                desc: t('win3_d_item4_t'),
                title: (
                    <div className="win3_item_title">
                        <EfIcon className="win3_item_title_icon" pc="https://websiteoss.ecoflow.com/upload/image/1723728127912/d4.png" />
                        <div className="win3_item_title_text">{t('win3_d_item4_b')}</div>
                    </div>
                ),
            },
        ],
    };

    const listAll = [listA, listB, listC, listD];

    return (
        <div className={styles.modal}>
            <EfProductCompareC items={listAll} theme="transparent" isUseFirstGray={false} />
        </div>
    );
}
